import { render, staticRenderFns } from "./LiveFace.vue?vue&type=template&id=a0087bd8&"
import script from "./LiveFace.vue?vue&type=script&lang=js&"
export * from "./LiveFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports